import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";

function parseBookingDate(bookingTime) {
  if (!bookingTime) return null;
  const raw = String(bookingTime).trim();
  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

function ConfirmedEnquiries({ approvedList, keyword, searchDate }) {
  const { reservationLoading } = useContext(AppContext);
  const [displayList, setDisplayList] = useState(null);

  useEffect(() => {
    if (!approvedList) return;
    setDisplayList(approvedList);
  }, [approvedList]);

  useEffect(() => {
    filterData(searchDate, keyword);
  }, [keyword, searchDate, approvedList]);

  const filterData = (date, keywordValue) => {
    if (!approvedList || !Array.isArray(approvedList)) return;

    let filteredData = approvedList.filter(
      (data) => data?.status === "Approved"
    );

    const now = new Date();
    filteredData = filteredData.filter((data) => {
      const bookingDate = parseBookingDate(data.bookingTime);
      if (!bookingDate) return true;
      return bookingDate >= now;
    });

    if (date) {
      const selected = new Date(`${date}T00:00:00`);
      filteredData = filteredData.filter((data) => {
        const bookingDate = parseBookingDate(data.bookingTime);
        if (!bookingDate) return false;
        return (
          bookingDate.getFullYear() === selected.getFullYear() &&
          bookingDate.getMonth() === selected.getMonth() &&
          bookingDate.getDate() === selected.getDate()
        );
      });
    }

    if (keywordValue && keywordValue.length !== 0) {
      const kw = keywordValue.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          item?.name?.toLowerCase?.().includes(kw) ||
          item?.email?.toLowerCase?.().includes(kw) ||
          item?.formattedID?.toLowerCase?.().includes(kw) ||
          String(item?.phone || "").includes(keywordValue)
      );
    }

    setDisplayList(filteredData);
  };

  return (
    <Fragment>
      <EnquiryListPanel
        title="Approved reservations"
        items={displayList}
        loading={reservationLoading}
        emptyMessage="No Confirmed Enquiries"
        showStatus
      />
    </Fragment>
  );
}

export default ConfirmedEnquiries;
